export type CookieOptions = {
  maxAge?: number
  path?: string
  sameSite?: "Lax" | "Strict" | "None"
  secure?: boolean
}

export const setCookie = (
  name: string,
  value: string,
  options: CookieOptions
) => {
  const parts = [`${name}=${encodeURIComponent(value)}`]

  if (options.maxAge !== undefined)
    parts.push(`Max-Age=${Math.max(0, Math.floor(options.maxAge))}`)
  if (options.path) parts.push(`Path=${options.path}`)
  if (options.sameSite) parts.push(`SameSite=${options.sameSite}`)
  if (options.secure) parts.push("Secure")

  const cookieString = parts.join("; ")
  const sizeInBytes = new Blob([cookieString]).size

  document.cookie = cookieString

  console.log(`[Cookie] Set "${name}": (${(sizeInBytes / 1024).toFixed(2)} KB)`)
}

export const getCookie = (name: string) => {
  const cookie = document.cookie
    .split(";")
    .map(part => part.trim())
    .find(part => part.startsWith(`${name}=`))

  if (!cookie) return null

  return cookie.substring(name.length + 1)
}

export const deleteCookie = (name: string) => {
  setCookie(name, "", {
    maxAge: 0,
    path: "/",
    sameSite: "Lax",
    secure: window.location.protocol === "https:",
  })
}

export const getAllCookies = () => {
  return document.cookie
    .split(";")
    .map(part => part.trim())
    .reduce((acc, cookie) => {
      const [name, value] = cookie.split("=")
      if (name && value) {
        acc[name] = decodeURIComponent(value)
      }
      return acc
    }, {} as Record<string, string>)
}

export const cookieUtils = {
  setCookie,
  getCookie,
  deleteCookie,
  getAllCookies,
}

// Expose cookie utilities on window for debugging
if (typeof window !== "undefined") {
  // @ts-expect-error this is safe to do
  window.cookieUtils = cookieUtils
}
